import React, { useEffect, useState } from "react";
import { osName, osVersion, browserName, browserVersion, mobileVendor, mobileModel, CustomView } from 'react-device-detect';
import { createGlobalStyle } from 'styled-components';
import Taskbar from './Taskbar';
import Desktop from './Desktop';
import IntroModal from '../applications/intro/Intro';
import { useRecoilState } from "recoil";
import { DeviceDetail } from "../recoil/atom/deviceDetail";
import { BrowserDetail } from "../recoil/atom/browserDetail";

const LoginPageOverride = createGlobalStyle`

body{
font-size: .75em;
font-family: monospace;
background-color: #02111B;
background-image: url("");
color: #FFFAFB;
margin: 0;
}

.text-container::-webkit-scrollbar {
  display: none;
}
@keyframes animate {
0% {
  width: 0px;
}
100% {
  width: 100%;
}
}
@keyframes fadeIn {
0% { opacity: 0; }
100% { opacity: 1; }
}
.blinking-cursor {
font-weight: 100;
color: white;
-webkit-animation: 1s blink step-end infinite;
-moz-animation: 1s blink step-end infinite;
-ms-animation: 1s blink step-end infinite;
-o-animation: 1s blink step-end infinite;
animation: 1s blink step-end infinite;
background-color: white;
font-size: 1em;
}

@keyframes "blink" {
from, to {
  color: transparent;
}
50% {
  color: black;
}
}

@-moz-keyframes blink {
from, to {
  color: transparent;
}
50% {
  color: black;
}
}

@-webkit-keyframes "blink" {
from, to {
  color: transparent;
}
50% {
  color: black;
}
}

@-ms-keyframes "blink" {
from, to {
  color: transparent;
}
50% {
  color: black;
}
}

@-o-keyframes "blink" {
from, to {
  color: transparent;
}
50% {
  color: black;
}
}

.content-block {
padding: .5em;
margin: .5em;
border: solid .1em #;
height: 97vh;
}
`;

function Login({ setIsBooting }) {
  const device = DeviceDetail();
  const browser = BrowserDetail();
  const [logoFontSize, setFontSize] = useState('4px');
  const [logoBannerSize, setBannerSize] = useState('6px');

  const [introModalOpened, toggleIntro] = useState(false);

  useEffect(() => {
    function calculateSizing() {
      let multiplier = 4;
      let bannerSize = 5;
      if(device.width > 200 && device.width < 330) {
        multiplier = 5;
        bannerSize = 6.5;
      } else if (device.width >= 330 && device.width < 450) {
        multiplier = 6;
        bannerSize = 8;
      } else {
        multiplier = 7;
        bannerSize = 9;
      }
      let customSize = Math.max(device.width / 1000, multiplier);
      setFontSize(`${customSize}px`);
      setBannerSize(bannerSize);
    }

    calculateSizing();
  }, [device.width, device.height]);

  useEffect(() => {
    const timer = setTimeout(() => {
      introModalToggle();
    }, 5250);

    return () => clearTimeout(timer);
  }, []);

  const introModalToggle = () => {
    setIsBooting(false);
  }

  return (
    <>
      <LoginPageOverride />
      <div className="content-block">
        <div width="auto" height="auto" className="sc-cHPgQl gNQJFa">
          <div
            className="body"
            style={{
              minHeight: "100%",
              display: "grid",
              margin: "auto"
            }}>
            <div style={{ lineHeight: "1em" }}>
              <div style={{ whiteSpace: "pre-wrap", fontSize: logoFontSize, lineHeight: 1, color: "#6BF178", fontWeight: 700 }}>{String.fromCharCode(46) + String.fromCharCode(45) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(39) + String.fromCharCode(46) + String.fromCharCode(46) + String.fromCharCode(46) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(46) + String.fromCharCode(46) + String.fromCharCode(46) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(46) + String.fromCharCode(46) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(32) + String.fromCharCode(46) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(46) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58) + String.fromCharCode(58)}</div>
              <div style={{ whiteSpace: "pre-wrap", fontSize: logoFontSize, lineHeight: 1, color: "#6BF178", fontWeight: 700 }}>{String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(39) + String.fromCharCode(39) + String.fromCharCode(39) + String.fromCharCode(39) + String.fromCharCode(32) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(39) + String.fromCharCode(39) + String.fromCharCode(39) + String.fromCharCode(39) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(96) + String.fromCharCode(96) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(96) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(96) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(59) + String.fromCharCode(39) + String.fromCharCode(39) + String.fromCharCode(39) + String.fromCharCode(39) + String.fromCharCode(10)}</div>
              <div style={{ whiteSpace: "pre-wrap", fontSize: logoFontSize, lineHeight: 1, color: "#6BF178", fontWeight: 700 }}>{String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(44) + String.fromCharCode(44) + String.fromCharCode(61) + String.fromCharCode(61) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(39) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(39) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(32) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(44) + String.fromCharCode(47) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(39) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(39) + String.fromCharCode(91) + String.fromCharCode(61) + String.fromCharCode(61) + String.fromCharCode(47) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(44) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(91) + String.fromCharCode(91) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32)}</div>
              <div style={{ whiteSpace: "pre-wrap", fontSize: logoFontSize, lineHeight: 1, color: "#6BF178", fontWeight: 700 }}>{String.fromCharCode(96) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(34) + String.fromCharCode(96) + String.fromCharCode(96) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(32) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(99) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(39) + String.fromCharCode(39) + String.fromCharCode(39) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(36) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(36) + String.fromCharCode(36) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(10)}</div>
              <div style={{ whiteSpace: "pre-wrap", fontSize: logoFontSize, lineHeight: 1, color: "#6BF178", fontWeight: 700 }}>{String.fromCharCode(32) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(46) + String.fromCharCode(100) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(44) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(46) + String.fromCharCode(100) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(32) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(98) + String.fromCharCode(32) + String.fromCharCode(34) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(98) + String.fromCharCode(111) + String.fromCharCode(44) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(32) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(98) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(100) + String.fromCharCode(80) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(56) + String.fromCharCode(56) + String.fromCharCode(44) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32)}</div>
              <div style={{ whiteSpace: "pre-wrap", fontSize: logoFontSize, lineHeight: 1, color: "#6BF178", fontWeight: 700 }}>{String.fromCharCode(32) + String.fromCharCode(34) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(44) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(34) + String.fromCharCode(89) + String.fromCharCode(109) + String.fromCharCode(109) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(34) + String.fromCharCode(34) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(34) + String.fromCharCode(89) + String.fromCharCode(109) + String.fromCharCode(109) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(34) + String.fromCharCode(34) + String.fromCharCode(32) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(34) + String.fromCharCode(87) + String.fromCharCode(34) + String.fromCharCode(32) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(34) + String.fromCharCode(89) + String.fromCharCode(77) + String.fromCharCode(109) + String.fromCharCode(77) + String.fromCharCode(89) + String.fromCharCode(34) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(77) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32) + String.fromCharCode(32)}</div>
              <span style={{ color: "#6BF178", fontWeight: 700, fontSize: logoBannerSize }}>×º°”˜`”°º×</span><span className="printchar" style={{ whiteSpace: "pre-wrap", fontSize: logoBannerSize, fontWeight: 700 }}> pwning ur mind since 99 </span><span style={{ color: "#6BF178", fontWeight: 700, fontSize: logoBannerSize}}>×º°”`˜”°º×</span>
              <p className="printchar text-load-in" style={{ animation: ".5s linear .25s both animate" }}>
                {`> Accessing device..`}
              </p>

              <p className="printchar text-load-in text-status-complete" style={{ animation: ".1s linear .5s both animate" }}>
                COMPLETE
              </p>

              <p className="printchar text-load-in" style={{ animation: ".5s linear 1s both animate" }}>
                {`> Loading device information..`}
              </p>

              <p className="printchar text-load-in" style={{ animation: ".1s linear 1.5s both animate" }}>
                {browser.mobileVendor !== "none" &&
                  <>
                    <span>Vendor: </span><span className="text-status-complete">{browser.mobileVendor}</span> <br />
                  </>
                }
                {browser.mobileModel !== "none" &&
                  <>
                    <span>Model: </span><span className="text-status-complete">{browser.mobileModel}</span> <br />
                  </>
                }
                {`Device OS: `}<span className="text-status-complete">{browser.osName}</span> <br />
                {`OS Version: `}<span className="text-status-complete">{browser.osVersion}</span>
              </p>


              <p className="printchar text-load-in" style={{ animation: ".5s linear 2s both animate" }}>
                {`> Accessing browser data..`}
              </p>

              <p className="printchar text-load-in" style={{ animation: ".1s linear 2.5s both animate" }}>
                {`Browser Name: `}<span className="text-status-complete">{browser.browserName}</span> <br />
                {`Browser Version: `}<span className="text-status-complete">{browser.browserVersion}</span>
              </p>

              <p className="printchar text-load-in" style={{ animation: ".5s linear 3s both animate" }}>
                {`> Checking browser compatibility..`}
              </p>

              <p className="printchar text-load-in text-status-complete" style={{ animation: ".1s linear 3.5s both animate" }}>
                COMPLETE
              </p>

              <p className="printchar text-load-in" style={{ animation: ".5s linear 4s both animate" }}>
                {`Web Bluetooth Enabled? `} {
                  browser.is_supported ? (
                    <>
                      <span className="text-status-complete">{browser.is_supported.toString()}</span>

                    </>
                  )
                    :
                    <>
                      <span style={{ color: "coral" }}>{browser.is_supported.toString()}</span>
                    </>
                }
              </p>

              <p className="printchar text-load-in" style={{ animation: ".5s linear 4.5s both animate" }}>
                {`> Launching intro..`}
              </p>

              <p className="printchar text-load-in text-status-complete" style={{ animation: ".1s linear 5s both animate" }}>
                COMPLETE
              </p>

            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default Login;
